import React from "react";
import { useState } from "react";
import { IoMdCloseCircle, IoIosArrowDroprightCircle } from "react-icons/io";
import "./ship_campus.css";

const ShipInCampus = () => {
  const [selectedCard, setSelectedCard] = useState(null);

  const cards = [
    {
      id: 1,
      name: "Ship In Campus",
      image: "/assets/images/Laboratory/Ship in Campus Lab.webp",
      description1:
        "The Ship-in-Campus, heart of MANET as regard to practical on-board training, named as Training Ship Vishwanath was established conforming to the guidelines of Directorate General of Shipping, Government of India and adheres to STCW/ IMO requirements. It was certified by Dr. S. C. Misra (Consultant appointed by D. G. Shipping, Government of India) Naval Architecture and a professor from IIT Kharagpur. The state's first and India's 5th 'Ship-In-Campus' facility was Inaugurated on 26th October 2007 by the hands of Hon. Shri Ajoy Chatterjee, Chief Surveyor with Govt. of India, D.G. Shipping and Chief Examiner of Engineers. ",
      description2:
        "The ship-in-campus is installed with various ship board machineries e.g. Main Engine with propeller, Auxiliary Engines, Auxiliary Boiler, Steering Gear System with rudder, Oil purifiers, Fresh Water Generator, Oily Water Separator, Refrigeration plant, various types of pumps, compressors, all types of systems, Main Switch Board, various electrical equipment, Wheel House equipped with Navigational Equipment etc. to impart effective training to the cadets. It covers around 1152 hours of practical training such as starting, operation, faulty finding and maintenance of the machinery installed for better understanding by the cadets.",
    },
    {
      id: 2,
      name: "Material Science Laboratory",
      image: "/assets/images/Laboratory/Material Science Lab.webp",
      subtitle: "Lab Equipment",
      description1:
        "This lab imparts training on Destructive and Non- destructive Testing - Destructive testing comprises tensile test, Compression Test, Bend Test, Hardness test, Impact test. Non-destructive testing comprises Ultrasonic test, Magnetic particle test and dye penetrate test.",
      description2: [
        "Universal Testing Machine",
        "Hardness Testing Machine",
        "Impact Testing Machine",
        "Ultrasonic Testing Machine",
        "Magnetic Particle Testing Machine",
      ],
    },
    {
      id: 3,
      name: "Electronics Laboratory",
      image: "/assets/images/Laboratory/Electronics_Lab.webp",
      description1:
        "Electronics engineering in respect to a marine engineer, pertains primarily to electronic circuits, circuit element equipment and systems for purpose such as communication, during lab hands on experience is provided to ensure that the students are proficient in the use of electronic test equipment such as cathode ray oscilloscope (CRO), function generator, dc power supply, digital multimeters, the reading and interpretation of schematics, and the use of technical manuals for trouble shooting and for routine electronic maintenance.",
      subtitle: "Salient features",
      description2: [
        "Highly calibrated electronics equipment like cathode ray oscilloscope (CRO), function generators, dual power supply, digital multimeter, ammeter etc.",
        "Well-designed trainer kits and experiment kits.",
        "Hands-on experience staff available.",
        "Manual and charts of equipment, trainer kits are readily available for information",
        "Safety and precaution requirements are fulfilled.",
      ],
    },

    {
      id: 4,
      name: "Electrical Laboratory",
      image: "/assets/images/Laboratory/Electrical Lab.webp",
      description1:
        " 'Electricity Saved is Electricity Generated Man', and marine life have seen unbelievable changes in past few decades. From the row boats and sail boats to steam powered ships and today to the state-of-art gas turbine operated ships Marine technology has witnessed colossal changes. The modern ship is almost feather touch operated with a major stress on the Electrical fade of the modern machines. To groom excellence in Marine Engineering, MANET has established modern state-of-the-art electrical laboratory to meet and overcome these challenges.",
      subtitle:
        "The laboratory is equipped with modern Electrical machines and various types of electrical instruments ",
      description2: [
        "Paralleling of alternators: The working model of two identical alternators driven by D.C. shunt motors consists of phase sequence indicator, frequency meters, voltmeters, synchro scope used to make satisfactory parallel operation of alternators on board ship. The experimental set is provided with various protective systems and safety devices",
        "Transformer Panel: To study different transformer polyphase connections, parallel operation and load sharing of transformers, polarity test, open circuit and short circuit test to evaluate efficiency of transformer 3. Induction motor-D.C. generator set: The panel consists of 3 ph, 5 h.p. induction motor with DOL starter and 3 KW D.C. shunt generator to find different performance characteristics of generator.",
        "Synchronous motor Panel: To study effects of excitation on armature current and p.f. of synchronous motor.",
        "Induction motor Panel: consists of 3 ph, 5 h.p. induction motor with brake drum arrangement to find performance characteristics of motor like torque, slip, efficiency etc.",
        "Universal motor Panel: To study the operation of motor on A.C. and D.C. supply and evaluate performance characteristics",
        "Alternator: To calculate the voltage regulation of alternator in leading, lagging and at unity power factor 8. Engine order Telegraph system: The study working of Synchro transmitter and receiver system",
        "Controllers: Study of single phase and three phase controllers.",
        "Theorems: - study of various theorems i.e. superposition, Thevenin's etc. ",
        "Load characteristics: Single phase induction motor load characteristics. ",
        " Bridge circuits: Finding unknown resistance by using bridge circuits ",
        "Resonance: study of resonance under series and parallel circuit",
      ],
      description3:
        "Lab also includes kits for measurement of various electrical quantities like power, resistance, energy, resonance, illumination etc. All the measuring instruments are panel mounted and connections are done by patch cords",
    },
    {
      id: 5,
      name: "Heat Transfer Lab",
      image: "/assets/images/Laboratory/Heat Transfer Lab.webp",
      description1:
        "Machines like refrigeration and air conditioning system, various engines, insulation applied on various pipelines and structure require knowledge of heat transfer. Heat transfer laboratory is designed to keep in mind all these requirements. The laboratory contains equipment to check flow of fluid, heat transfer through metallic rod, insulators and calorific values of fuels. This will not only enhance the theoretical knowledge of the cadets but also imparts a practical understanding and a feel of heat transfer and its application on board ships.",
      subtitle: "Salient features ",
      description2: [
        "Hydraulic bench apparatus- measurement of flow by venturi meter, orifice, notches. Calculation of coefficient of friction for various pipes is also demonstrated which is used to determine pump capacity on board ship.",
        "Heat transfer apparatus - to calculate heat transfer through pin fin, metal rod which is used in the design of heat exchangers.",
        "Thermal conductivity of insulating powder is used for calculating heat transfer through boiler walls and pipelines.",
        "Bomb calorimeters to calculate calorific value of fuel are used to decide the type of fuel used in a system. 5. Redwood and say bolt viscometer are used to calculate the viscosity of oil on board ship.",
        "Redwood and say bolt viscometer are used to calculate the viscosity of oil on board ship.",
        "Refrigeration system used in lab guidelines to understand the construction and working of refrigeration on board ship.",
        "Reciprocating compressor test rig gives guidelines to cadets about working and efficient use of compressor for various purposes on board ships.",
      ],
    },
    {
      id: 6,
      name: "Mechanical Laboratory",
      image: "/assets/images/Laboratory/Mechanical Lab.webp",
      description1:
        "Laboratory experiments are backbone of technical education. The experiments carried out in this laboratory are directly related to machinery equipment onboard ships. Visualization helps us to understand fundamentals of any equipment which the trainees will come across while working onboard ships. It will help them to develop or design a device, fabricate & test.",
      subtitle: "Vision",
      description2:
        "Students are expected to learn. the relation between these experiments & machinery on-board",
      subtitle: "Salient features ",
      description2: [
        "Various experiments & their applications in Marine Engineering. ",
        "Cam Follower: Applied in Fuel Pumps, Exhaust Valve Actuators etc.",
        "Universal Testing Machine: Vibrations of Shaft lines, Crankshaft etc.",
        "Belt Drives: Compressor, Pumps etc.",
        "Governor: Hydraulic & Mechanical Governors exclusively.",
      ],
    },
    {
      id: 7,
      name: "Marine Control & Simulator Laboratory",
      image: "/assets/images/Laboratory/Marine Control and Automation Lab.webp",
      description1:
        "All machinery on ships must operate within certain desired parameters. Instrumentation enables the pressure, flow, level etc., to be measured or displayed against a scale. Control is also required to change or alter the displayed reading to meet requirement. Control must be manual (opening or closing of the valves) or automatic where change in the parameter results in action which return the valve to desire point without human involvement.",
      subtitle: "Salient features ",
      description2: [
        "Lab is equipped with modern SCADA (PID) system which controls the parameters like flow, pressure and level manually as well as automatically.",
        "Hydraulic and pneumatic training kits guide cadets to understand and work on equipment on board ships such as cranes, steering gears, governors of engines etc.",
        "Programmable logic controller (PLC) gives knowledge about automatic control of parameters such as level in fuel or water tank, stepper moto control to control radar system by programming on computers.",
        "Various charts of hydraulic valves are provided to understand construction and working of them.",
      ],
    },
    {
      id: 8,
      name: "Computer Science Laboratory",
      image: "/assets/images/Laboratory/Computer Lab.webp",
      description1:
        "We are living in the computer age. Today computers are used in a wide range of applications. Whether it is a medical application, industrial application or a marine application, computers are used to solve complex problems in an efficient manner in a short time. Since there are many engineering tasks necessary to keep a ship running, Marine engineering, like other technical disciplines, has become highly automated and reliant on computers. Computer technology is now available to help marine engineers at sea, so today's marine training must include a good foundation in computer skills.",
      description2:
        "MANET prepares students for the increasing usage of computer systems board merchant vessels; the institute offers several computer skills courses focusing on computer-aided drafting and data acquisition and analysis.",
      subtitle: "Lab Facilities",
      description2:
        "A modern computer laboratory equipped with high performance servers is available on the campus. A wealth of software and several operating system platforms provide extensive opportunities and capabilities for info- tech training as well as the use of modern teaching methods like simulation and computer-based instruction.",
      subtitle: "Lab  features ",
      description2: [
        "Leased line with 100 MBPS",
        "Separate Server room. Server supports well oriented structured network.",
        "Internet facility available.",
        "Operating Systems: Windows 8 Pro, Windows 10.",
        "List of Software's: MS-Office 2016, C, C++, SMMS (Ship Maintenance Management System)",
        "Total 50 PCS (CORE I5) with 8 GB RAM (B. Tech Computer Lab).",
      ],
    },
    {
      id: 9,
      name: "Applied Mechanics Laboratory",
      image: "/assets/images/Laboratory/Applied Mechanics Lab.webp",
      description1:
        "This lab has a few machines which help the cadets in visualizing basic forces & mechanisms involved in engineering design.",
      subtitle:
        "This lab imparts training on analyzing following engineering elements ",
      description2:
        "A modern computer laboratory equipped with high performance servers is available on the campus. A wealth of software and several operating system platforms provide extensive opportunities and capabilities for info-tech training as well as the use of modern teaching methods like simulation and computer-based instruction.",
      description2: [
        "Moment of forces.",
        "Reaction of forces.",
        "Equilibrium of forces.",
        "Resolution of forces.",
        "Mechanical advantage & efficiency.",
        "Moment of inertia and friction.",
      ],
    },
    {
      id: 10,
      name: "Navigation Laboratory",
      image: "/assets/images/Laboratory/Navigation Lab.webp",
      description1:
        "Navigation is the process of reading and controlling the movement of a craft from one place to another. It is also the term of art used for the specialized knowledge used by navigators to perform navigational tasks. The word navigate is derived from the Latin NAVIGARE , meaning TO SAIL . Navigational techniques include Bridge Simulator - for training cadets in the use of ECDIS, Radar plotting, Steering and applying the knowledge of International Regulations for Preventing Collisions at Sea to maintain safety of navigation.",
    },
    {
      id: 11,
      name: "Engine Workshop",
      image: "/assets/images/Laboratory/engine_workshop.webp",
      description1:
        "The Engineering Workshop serves as a foundation for understanding basic materials and manufacturing processes. As machine tools are regarded as the Mother Of All Machines, the workshop plays a crucial role in shaping the technical skills and practical understanding of students in manufacturing technology. The workshop is divided into three major sections that enable hands-on experience and development in core areas of production:",

      sections: ["Machine Shop", "Welding Shop", "Fitting and Plumbing Shop"],

      subdescription1:
        "Each section provides cadets with practical exposure to industrial practices, machining operations, fabrication, assembly, and maintenance techniques.",

      subtitle: "Value-Added Training: 4G Welding (SMAW)",
      description2:
        "To enhance employability and technical proficiency, the department has introduced an Advanced SMAW (Shielded Metal Arc Welding) - 4G Position Welding Course exclusively for B. Tech Marine Engineering cadets. The 4G (Overhead) Welding Position is one of the most challenging techniques in plate welding and is commonly required in fixed structural applications where overhead welding is unavoidable. Through this specialized training, cadets gain expertise in horizontal, vertical, and overhead welding positions. This value-added course, recommended by MAERSK Shipping Company, significantly boosts the cadets' professional competence and career prospects in the marine and shipping industries. Upon successful completion, cadets are awarded a Competency Certificate recognizing their advanced welding skills. The Engineering Workshop thus plays a vital role in nurturing skilled, confident, and industry-ready marine engineers equipped with both fundamental and advanced manufacturing capabilities.",
    },
    {
      id: 12,
      name: "Engine Simulator Laboratory",
      image: "/assets/images/Laboratory/Engine Simulator Lab.webp",
      description1:
        "The Engine room simulator is designed to demonstrate trouble shoot generic Slow speed Reversible Diesel Engine Start System and numerous other auxiliary systems. The design incorporates all the machinery onboard any Tanker ship and is very user friendly. The simulator helps cadets to easily understand complex systems. Various types of defects that usually come on running machinery can be easily simulated. The simulator has induced lot of confidence in the cadets to handle and work on lot of new machinery found on Tanker ships.",
    },
  ];

  return (
    <div>
      <h1 className="title">Ship in Campus (Laboratories & Simulators)</h1>
      <hr />
      <div className="shipcamp-card-grid">
        {cards.map((card) => (
          <div className="shipcamp-card" key={card.id}>
            <img
              src={card.image}
              alt={card.name}
              className="shipcamp-card-image"
              onClick={() => setSelectedCard(card)}
            />
            <div className="shipcamp-card-footer">
              <h4
                className="shipcamp-title"
                onClick={() => setSelectedCard(card)}
              >
                {card.name}
              </h4>
              <span
                className="shipcamp-open-icon"
                onClick={() => setSelectedCard(card)}
              >
                <IoIosArrowDroprightCircle />
              </span>
            </div>
          </div>
        ))}
      </div>

      {/* Modal */}
      {selectedCard && (
        <div
          className="shipcamp-modal-overlay"
          onClick={() => setSelectedCard(null)}
        >
          <div className="shipcamp-modal" onClick={(e) => e.stopPropagation()}>
            {/* Close icon */}
            <span
              className="shipcamp-close-icon"
              onClick={() => setSelectedCard(null)}
            >
              <IoMdCloseCircle size={30} />
            </span>

            <div className="shipcamp-modal-content">
              <div>
                {/* Card Name at the top */}
                {selectedCard.name && (
                  <h2 className="innerpage-heading" style={{borderBottom: "1.5px solid goldenrod", paddingBottom:"5px"}}>{selectedCard.name}</h2>
                )}
                {selectedCard.description1 && (
                  <p>{selectedCard.description1}</p>
                )}

                {selectedCard.sections && selectedCard.sections.length > 0 && (
                  <ul className="workshop-sections">
                    {selectedCard.sections.map((section, index) => (
                      <li key={index}>{section}</li>
                    ))}
                  </ul>
                )}

                {selectedCard.subdescription1 && (
                  <p>{selectedCard.subdescription1}</p>
                )}
              </div>
              {selectedCard.image && (
                <img
                  src={selectedCard.image}
                  alt={selectedCard.name}
                  className="shipcamp-modal-image"
                />
              )}
            </div>

            {selectedCard.subtitle && (
              <h4 className="innerpage-subheading">{selectedCard.subtitle}</h4>
            )}

            {/* Safe array rendering */}
            {Array.isArray(selectedCard.description2) &&
            selectedCard.description2.length > 0 ? (
              <ul className="page-content-lists">
                {selectedCard.description2.map((desc, index) => (
                  <li key={index}>{desc}</li>
                ))}
              </ul>
            ) : (
              selectedCard.description2 && <p>{selectedCard.description2}</p>
            )}

            {selectedCard.description3 && <p>{selectedCard.description3}</p>}
          </div>
        </div>
      )}
    </div>
  );
};

export default ShipInCampus;
